import { render, staticRenderFns } from "./RegisterDataForm.vue?vue&type=template&id=3311a88c&"
import script from "./RegisterDataForm.vue?vue&type=script&lang=js&"
export * from "./RegisterDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports